'use client';

import * as Tooltip from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import React, { useState } from 'react';
import styles from './Tooltip.module.scss';
export const TooltipComponent = ({
  children,
  className,
  classNameArrow,
  side
}: {
  children: ReactNode;
  className?: string;
  classNameArrow?: string;
  side: Tooltip.TooltipContentProps['side'];
}) => {
  const [open, setOpen] = useState(false);
  return <Tooltip.Provider delayDuration={100} data-sentry-element="unknown" data-sentry-component="TooltipComponent" data-sentry-source-file="Tooltip.tsx">
      <Tooltip.Root onOpenChange={setOpen} open={open} data-sentry-element="unknown" data-sentry-source-file="Tooltip.tsx">
        <Tooltip.Trigger asChild onClick={() => setOpen(true)} style={{
        cursor: 'pointer'
      }} data-sentry-element="unknown" data-sentry-source-file="Tooltip.tsx">
          <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg' data-sentry-element="svg" data-sentry-source-file="Tooltip.tsx">
            <path clipRule='evenodd' d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 9.84604C9 8.1999 10.4196 7 12 7C13.5804 7 15 8.1999 15 9.84604C15 11.1482 14.0744 11.8086 13.5393 12.1415L13.5381 12.1422C13.3116 12.2827 13.1761 12.3915 13.0951 12.4923C13.034 12.5683 13 12.6421 13 12.7692V13.5H11V12.7692C11 11.4518 11.9349 10.7832 12.4832 10.443C12.7038 10.3057 12.834 10.2006 12.9112 10.1045C12.9686 10.033 13 9.96516 13 9.84604C13 9.4523 12.6296 9 12 9C11.3704 9 11 9.4523 11 9.84604H9ZM11 17V15H13V17H11Z' fill='black' fillRule='evenodd' data-sentry-element="path" data-sentry-source-file="Tooltip.tsx" />
          </svg>
        </Tooltip.Trigger>

        <Tooltip.Content className={clsx(styles.TooltipContent, className)} side={side} sideOffset={2} data-sentry-element="unknown" data-sentry-source-file="Tooltip.tsx">
          {children}
          <Tooltip.Arrow className={clsx(styles.TooltipArrow, classNameArrow)} data-sentry-element="unknown" data-sentry-source-file="Tooltip.tsx" />
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};